import { connect, Dispatch } from 'react-redux';

import { Action } from '../../actions';
import { fetchRemoveMarketerProductAccess } from '../../actions/marketers/marketerCard';
import {
    MarketerProductRemoveCell,
    MarketerProductRemoveCellProps
} from '../../components/MarketerProductRemoveCell/MarketerProductRemoveCell';
import { MarketerProductsCellItem } from '../../typings/marketers';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<MarketerProductRemoveCellProps>;
type DispatchProps = TDispatchProps<MarketerProductRemoveCellProps>;
type OwnProps = MarketerProductsCellItem;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    return {
        isRemoving: ownProps.isRemoving
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    return {
        removeMarketerProduct: () =>
            dispatch(fetchRemoveMarketerProductAccess(ownProps.id))
    };
};

export const MarketerProductRemoveCellContainer = connect<
    StateProps,
    DispatchProps
>(
    mapStateToProps,
    mapDispatchToProps
)(MarketerProductRemoveCell);
